







import { Vue, Component } from "vue-property-decorator";
import WebCam from "../components/WebCam.vue"
import Display from "../components/Display.vue"
import Upload from "../components/Upload.vue"

@Component({
  name: "Home",
  components: {
    WebCam,
    Upload,
    Display
  }
})

export default class Home extends Vue {}
